import axios from 'axios'
import { textRegEx } from '../../utils/constants'
import { getDeepClone } from './helpers'

export async function configureDataBeforeRecord(data) {
  const clone = getDeepClone(data)

  const textFields = ['description', 'title', 'name']
  const fileFields = ['file', 'image']

  textFields.forEach((attr) => {
    if (clone[attr]) clone[attr] = clone[attr].trim().replace(textRegEx, ' ')
  })

  for (let attr of fileFields) {
    if (clone[attr]) {
      //Если файл уже существует в записи (при редактировании, просто назначаем свойству image ссылку (IRI) на файл)
      if (clone[attr].id) {
        clone[attr] = `/files/${clone[attr].id}`
      }
      //Если файл загружаем новый, то следует сначала отправить его на сервер, получив ссылку на него (IRI)
      if (clone[attr]?.rawFile) {
        clone[attr] = await uploadFile(clone[attr])
      }
    }
  }

  if (clone.cities) clone.city = `cities/${clone.cities.id}`
  delete clone.cities

  return clone
}

export async function uploadFile(field) {
  const fd = new FormData()
  fd.set('file', field.rawFile)
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_PATH}/files`,
      fd,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          Accept: 'application/json',
        },
      }
    )
    return `/files/${response.data.id}`
  } catch (err) {
    return Promise.reject(err)
  }
}
